import { Types } from "../../actions/user/registerUser.actions";

const INITIAL_STATE = {
  success: false,
  loading: false,
  error: null
};

export default function registerUser(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.REGISTER_USER: {
      return {
        ...state,
        ...INITIAL_STATE,
        loading: true
      };
    }

    case Types.REGISTER_USER_ERROR: {
      return {
        ...state,
        success: false,
        loading: false,
        error: action.payload
      };
    }

    case Types.REGISTER_USER_SUCCESS: {
      return {
        ...state,
        success: true,
        loading: false
      };
    }

    case Types.REGISTER_USER_RESET: {
      return {
        ...state,
        ...INITIAL_STATE
      };
    }

    default:
      return state;
  }
}
